import CaretButton from '@components/bits/CaretButton/CaretButton';
import React from 'react';

import styles from './index.module.scss';

const FooterGoBackColumn = (): JSX.Element => {
  return (
    <div className={styles.goback + ' ' + 'dark'}>
      <CaretButton
        dir="up"
        onClick={() => {
          window.scrollTo(0, 0);
        }}>
        Til toppen
      </CaretButton>
    </div>
  );
};

export default React.memo(FooterGoBackColumn);
